<template>
  <div class="container dashboard">
    <div class="header">
      <h3>Welcome to the iPro<span class="trademark">&reg;</span> Systems Management Portal</h3>
      <h4>Manage Your Business the <i>Right</i> Way.</h4>
    </div>
    <p>This is the future home of your dashboard.</p>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard.vue